<template>
  <div class="video-page-wrapper">
    <IphoneVideo :video-name="require('@/assets/videos/speakers_music.mp4')"></IphoneVideo>
    <PageTabs>
      <template v-slot:first>
        <div class="video-page-texts video-page-texts-no-offset">
          <div>
            <h3>{{ $t("pages.music.subtitle1") }}</h3>
            <p>{{ $t("pages.music.text1") }}</p>
          </div>
          <div>
            <h3>{{ $t("pages.music.subtitle2") }}</h3>
            <p>{{ $t("pages.music.text2") }}</p>
          </div>
          <img class="img-music" src="@/assets/pages/integrations/airplay-devices.svg" alt="Airplay" />
        </div>
      </template>
      <template v-slot:second>
        <VoiceCommands :commands="commands"></VoiceCommands>
      </template>
    </PageTabs>

  </div>
</template>

<script>
import PageTabs from "../components/PageTabs";
import VoiceCommands from "../components/VoiceCommands";
export default {
  name: "Music",
  components: { VoiceCommands, PageTabs },
  data() {
    return {
      commands: this.$t("pages.music.commands")
    };
  }
};
</script>

<style scoped lang="scss">
.img-music {
  width: 100%;
  max-width: 160px;
}
</style>
